<div class="form-group">
  <label [for]="name">{{ placeholder | titlecase }}</label>
  <select
    [disabled]="disabled"
    class="form-select"
    [(ngModel)]="model"
    id="numselect"
    name="numselect"
    #errorModel="ngModel"
    (ngModelChange)="eventChange()"
    [required]="required"
  >
    <option *ngFor="let number of numbers" [ngValue]="number">
      {{ number }}
    </option>
  </select>
  <span
    class="text-danger"
    *ngIf="(model || myForm.submitted) && errorModel.errors?.required"
  >
    Il campo {{ placeholder | lowercase }} è obbligatorio
  </span>
</div>
